import { createContext } from 'react';
import initialTransactionsState from './initialTransactionsState';

const TransactionsContext = createContext(initialTransactionsState);

export default TransactionsContext;
